import { useState, useEffect } from 'react';

const constitutionalQuotes = [
    {
        text: 'Jamhuri ya Muungano wa Tanzania ni nchi yenye mfumo wa kidemokrasia na haki za kijamii.',
        author: 'Katiba ya Tanzania, Ibara ya 1'
    },
    {
        text: 'Mamlaka ya kuongoza nchi ni ya wananchi wenyewe kupitia chaguzi huru na haki.',
        author: 'Katiba ya Tanzania, Ibara ya 5'
    },
    {
        text: 'Kila mtu anastahili heshima na kutambuliwa kwa utu wake.',
        author: 'Katiba ya Tanzania, Ibara ya 12'
    },
    {
        text: 'Kila mtu ana haki ya kuwa huru na kuishi bila ubaguzi wa aina yoyote.',
        author: 'Katiba ya Tanzania, Ibara ya 13'
    },
    {
        text: 'Kila mtu ana haki ya kutoa mawazo yake na kupata habari bila kuvunja sheria.',
        author: 'Katiba ya Tanzania, Ibara ya 18'
    }
];


const Quotes = () => {
    const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsVisible(false);

            setTimeout(() => {
                setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % constitutionalQuotes.length);
                setIsVisible(true);
            }, 1000);
        }, 5000); // Change quote every 5 seconds

        return () => clearInterval(interval);
    }, []);

    const currentQuote = constitutionalQuotes[currentQuoteIndex];

    return (
        <div className="w-full mx-auto p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg text-center my-8">
            <p className={`text-xl italic text-gray-800 dark:text-gray-100 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>"{currentQuote.text}"</p>
            <p className={`text-sm text-gray-600 dark:text-gray-400 mt-2 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>— {currentQuote.author}</p>
        </div>
    );
};

export default Quotes;
